import React from "react";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";
import useDeviceCompatibility from "../../hooks/useDeviceCompatibility";

const MobileAppSuggestions = ({isMobileDevice}) => {
    const { androidAppLink: androidPlayStoreLink, iosApplink: iosAppStorelink, androidPlayStoreLargeImage, iosAppStoreLargeImage } = useTenantFeatures();
    const { deviceCompatibilityData: modalData } = useDeviceCompatibility();

    const description = modalData?.Description ;
    const supportedDevicesMsg = modalData?.SupportedDevicesMessage ;
    const isDisplayIosButton = modalData?.IsDisplayIosButton ?? true;
    const showAndroidButton = modalData?.ShowAndroidButton ?? true;

    // Use API URLs if available, otherwise fallback to tenant features
    const finalIosLink = modalData?.IosAppStoreUrl || iosAppStorelink;
    const finalAndroidLink = modalData?.AndroidPlayStoreUrl || androidPlayStoreLink;

    // Use API Images if available, otherwise fallback to tenant features
    const finalIosImage = modalData?.IosDownloadLargeScreenImage || iosAppStoreLargeImage;
    const finalAndroidImage = modalData?.AndroidDownloadLargeScreenImage || androidPlayStoreLargeImage;

    return (
        <div className="">
            {/*<p className="subheading">{isMobileDevice ? mobileAppSuggestionModalDescription : mobileAppSuggestionModalDescriptionForLargeDevice}</p>*/}
            <p className="subheading" style={{
                textAlign: "start"
            }}>
                {description}
                <br />
                <br />
                {supportedDevicesMsg}
            </p>

            <div className="mobile-app-suggestion-store-container">
                {/* App Store Button */}
                {isDisplayIosButton && (
                    <a href={finalIosLink} target="_blank" rel="noopener noreferrer" className="store-download-button">
                        <img className="apple" src={finalIosImage} alt="App Store" />
                    </a>
                )}

                {/* Google Play Button */}
                {showAndroidButton && (
                    <a href={finalAndroidLink} target="_blank" rel="noopener noreferrer" className="store-download-button">
                        <img className="playstore" src={finalAndroidImage} alt="Google Play" />
                    </a>
                )}

                {/*<IconCloseButton />*/}
            </div>
        </div>
    )
};

export default MobileAppSuggestions;
